import React, { ComponentType, useContext } from 'react';
import { AuthContext } from '../context/AuthProvider';

function withFlag<T>(Component: ComponentType<T>, flag: string) {
  return (hocProps: T) => {
    const user = useContext(AuthContext);
    if (!user?.flags?.includes(flag)) {
      return null;
    }
    return <Component {...hocProps} />;
  };
}

export default withFlag;
